module.exports = __webpack_public_path__ + "static/media/airbnb.0fb27b32.svg";